// extracted by css-extract-rspack-plugin
export default {"versionSummaryContainer":"oMEBLiqDcKQvOjyh"};